module.exports = __webpack_public_path__ + "media/images/emblems/Val-de-Charmey_Blason-a161eb23e811e49618a5b8b458541e7d.png";